export default __webpack_public_path__ + "static/media/close-icon.42fb4332.svg";